export default {
    root: ({props, state}) => {
        return {
            class: [
                "relative",
                "w-full",
                "h-full",
                "text-stone-900 dark:text-stone-50",
                "bg-stone-50 dark:bg-stone-900",
                "border border-stone-200 dark:border-stone-700",
                "rounded-md",
                "focus-within:ring-1 focus-within:ring-askr-green-400/50 ring-inset dark:focus-within:ring-askr-green-300/50",
                // "overflow-hidden",
            ],
        };
    },
    toolbar: {
        class: [
            "border-0 border-b border-stone-200 dark:border-stone-700",
            "bg-stone-100 dark:bg-stone-800",
            "p-2",
            "flex flex-wrap gap-1",
        ],
    },
    formats: {
        class: ["mr-2", "flex items-center"],
    },
    header: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "px-2 py-1",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "rounded",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    option: ({context}) => ({
        class: [
            "py-2 px-3",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-100 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    bold: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "w-7 h-7",
            "rounded",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    italic: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "w-7 h-7",
            "rounded",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    underline: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "w-7 h-7",
            "rounded",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    color: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "w-7 h-7",
            "rounded",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    background: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "w-7 h-7",
            "rounded",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    list: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "w-7 h-7",
            "rounded",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    select: ({context}) => ({
        class: [
            "inline-flex items-center",
            "px-2 py-1",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "rounded",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    link: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "w-7 h-7",
            "rounded",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    image: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "w-7 h-7",
            "rounded",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    codeBlock: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "w-7 h-7",
            "rounded",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    clean: ({context}) => ({
        class: [
            "inline-flex items-center justify-center",
            "w-7 h-7",
            "rounded",
            {"text-stone-700 dark:text-white/80": !context?.active},
            {"text-askr-green-500 dark:text-askr-green-400": context?.active},
            {"bg-askr-green-50 dark:bg-askr-green-900/20": context?.active},
            "hover:bg-stone-200 dark:hover:bg-stone-700",
            "transition-colors duration-200",
            "cursor-pointer",
        ],
    }),
    content: {
        class: [
            "p-4",
            "text-stone-800 dark:text-white/80",
            "h-full",
            // "overflow-auto"
        ],
    },
};
